import { useState } from 'react';
import { GetAgreementDocumentQueryVariables, useGetAgreementDocumentQuery } from 'views/utils/graphql/graphql';

export const useGetAgreementDocument = (initValues: GetAgreementDocumentQueryVariables) => {
  const [agreementDocumentVariables, setAgreementDocumentVariables] =
    useState<GetAgreementDocumentQueryVariables>(initValues);
  const [agreementDocument, getAgreementDocument] = useGetAgreementDocumentQuery({
    variables: agreementDocumentVariables,
    requestPolicy: 'network-only',
    pause: true,
  });

  return {
    agreementDocument,
    getAgreementDocument,
    setAgreementDocumentVariables,
  };
};
